import React, {FC} from 'react';
import styled from 'styled-components';

import {buildTeammateDisplayName} from '../../../../libs/shared/core/src/models/helpers/teammateModelHelpers';
import {getTeammates} from '../../../../libs/shared/core/src/store/data/teammates/commonTeammatesSelectors';
import {TeammateAvatar} from '../../../../libs/shared/ui/src/components/avatar/teammateAvatar';
import {VisualSizesEnum} from '../../../../libs/shared/ui/src/styles/commonStyles';
import {ellipsis} from '../../../../libs/shared/ui/src/styles/mixins';
import {useAppSelector} from '../../../helpers/appReduxHelpers';
import {StyledEllipsisWrapperDiv} from '../../components/reportViewer/reportCommons';
import {MetricResourceRenderer} from '../analyticsFormatHelpers';

/*
 * Styles.
 */

const StyledAvatar = styled(TeammateAvatar)`
  display: inline-block;
  vertical-align: middle;
  position: relative;
  margin-right: 4px;
`;

const StyledTeammatesName = styled.div`
  ${ellipsis()}
`;

/*
 * Formatter.
 */

const TeammateValue: FC<{teammateId: number; fallback: string; size?: VisualSizesEnum}> = ({
  teammateId,
  fallback,
  size,
}) => {
  const allTeammates = useAppSelector(getTeammates);
  const teammate = allTeammates[teammateId];

  if (!teammate) {
    return <>{fallback}</>;
  }

  return (
    <StyledEllipsisWrapperDiv>
      <StyledAvatar teammate={teammate} size={size || VisualSizesEnum.MEDIUM} />
      <StyledTeammatesName>{buildTeammateDisplayName(teammate)}</StyledTeammatesName>
    </StyledEllipsisWrapperDiv>
  );
};

export const renderTeammateValue: MetricResourceRenderer = ({id, value, size}) => (
  <TeammateValue teammateId={id} fallback={value} size={size} />
);
